import {
  HIDE_SPINNER,
  HIDE_SPINNER_DESCUENTO,
  SET_DESCUENTO,
  SET_DISCOUNT_CODE,
  SET_PAQUETE,
  SHOW_SPINNER,
  SHOW_SPINNER_DESCUENTO,
} from "../types";
import { SET_PAYMENTSOURCE } from "../types/PaymentSources";

const CheckoutReducer = (state, { type, payload }) => {
  switch (type) {
    case SET_PAQUETE:
      return { ...state, class_package: payload };
    case SET_DESCUENTO:
      return { ...state, descuento: payload, spinnerDescuento: false };
    case SET_PAYMENTSOURCE:
      return { ...state, payment_source: payload };
    case SET_DISCOUNT_CODE:
      return { ...state, discountCode: payload };
    case SHOW_SPINNER:
      return { ...state, spinner: true };
    case HIDE_SPINNER:
      return { ...state, spinner: false };
    case SHOW_SPINNER_DESCUENTO:
      return { ...state, spinnerDescuento: true };
    case HIDE_SPINNER_DESCUENTO:
      return { ...state, spinnerDescuento: false };
    default:
      return { ...state };
  }
};

export default CheckoutReducer;
